import React, { useEffect, useState } from 'react'
import { Outlet, useNavigate } from 'react-router-dom'
import Header from '../../components/header/Header';
import Sidebar from '../../components/sidebar/Sidebar';

function Layout() {
    const [innerWidth, setinnerWidth] = useState(window.innerWidth);
    const [stateVal, setStateVal] = useState(innerWidth > 992 ? true : false);
    const toggleSidebar = () => {
        setStateVal((prev) => !prev);
    };

    // const [user, setUser] = useState(null);
    // const navigate = useNavigate();

    //  useEffect(() => {
    //     let userData = localStorage.getItem('correl_id'); 
    //     if (!userData) {
    //         window.location.replace('/login'); 
    //     } else {
    //         setUser(userData);
    //     }
    // }, []);


    return (
        <div className={innerWidth > 992 ? 'web' : 'mobile'}>
            <Header stateVal={stateVal} trigger={toggleSidebar} />
            <div className="components">
                <Sidebar stateVal={stateVal} trigger={toggleSidebar} />
                <div className="mainContainer">
                    <Outlet />
                </div>
            </div>
        </div>
    )
}

export default Layout
